export default __webpack_public_path__ + "static/media/Girdle of the Revelations of Tarim.cd8db6e1.jpg";